module.exports = __webpack_public_path__ + "routes/home/ihub2_photo.jpg?6e1b56a5";


//////////////////
// WEBPACK FOOTER
// ./routes/home/ihub2_photo.jpg
// module id = 1343
// module chunks = 0